module.exports = __webpack_public_path__ + "static/robothor-pairings-30d2887fbc18de6255c431c1e15b17a7.gif";